<template>
  <v-container>
    <v-row>
      <v-col>
        <h2 v-if="cacheJourney.isJourney">{{$t('OrderedSetOfStories')}}</h2>
        <h2 v-else>{{$t('UnorderedSetOfStories')}}</h2>
      </v-col>
    </v-row>
    <v-row :style="calcoulateBackgroundColor" v-if="refreshComponentBackgroundColor">
      <v-col lg="12">
        <div id="app">
          <div class="list">
            <transition-group name="flip-list" tag="div">
              <div @dragover="(e) => onDragOver(C, i, e)" @dragend="(e) => finishDrag(singleStory, i, e)"
                @dragstart="(e) => startDrag(singleStory, i, e)"
                v-for="(singleStory, i) in cacheJourney.storiesArrayObjectIdDescription" class="singleStory mt-2"
                :class="{over: (singleStory === over.singleStory && singleStory !== dragFrom), [over.dir]: (singleStory === over.singleStory && singleStory !== dragFrom) }"
                draggable="true" :key="i+singleStory.id">
                <v-container>
                  <v-row align="center">

                    <v-col cols=12>
                      <v-container class="mt-0 pt-0 px-0 mx-0 mb-0 pb-0">
                        <v-row class="mt-0 pt-0 px-0 mx-0 mb-0 pb-0">
                          <!-- Insert singleStory.storiesArrayObjectIdDescription.descriptionStoryJourney-->
                          <v-textarea v-model="singleStory.descriptionStoryJourney"
                            v-on:keyup="setSingleStoryJurneyDescription(i,singleStory.descriptionStoryJourney,singleStory.id)"
                            auto-grow outlined rows="2" row-height="1"></v-textarea>
                        </v-row>
                        <v-row v-if="cacheJourney.isJourney" justify="space-around" align="center" class="mt-0 pt-0 px-0 mx-0 mb-0 pb-0">

                          <v-col justify="center" align="center" cols=1 class="mt-0 pt-0 px-0 mx-0 mb-0 pb-0">

                              <span v-if="i>0" @click="moveUpStory(i)" class="mdi mdi-arrow-up-bold"></span>

                            <v-avatar color="black" size="26" class="mt-2 mb-2">
                              <span class="white--text text-h6">{{i+1}}</span>
                            </v-avatar>

                              <span v-if="i<cacheJourney.storiesArrayObjectIdDescription.length-1" @click="moveDownStory(i)" class="mdi mdi-arrow-down-bold"></span>

                          </v-col>
                          <v-col cols=11>
                            <mediaFileStory v-if="singleStory.cover_image.media.formats.hasOwnProperty('small')"
                              :mediaUrl="apiStrapi + singleStory.cover_image.media.formats.small.url.replace(/ /g, '%20')"
                              type="image" :isLocal="false" :storyTitle="singleStory.title">
                            </mediaFileStory>
                          </v-col>
                        </v-row>
                        <v-row v-else justify="space-around" align="center" class="mt-0 pt-0 px-0 mx-0 mb-0 pb-0">

                          <v-col cols=12>
                            <mediaFileStory v-if="singleStory.cover_image.media.formats.hasOwnProperty('small')"
                              :mediaUrl="apiStrapi + singleStory.cover_image.media.formats.small.url.replace(/ /g, '%20')"
                              type="image" :isLocal="false" :storyTitle="singleStory.title">
                            </mediaFileStory>
                          </v-col>
                        </v-row>

                      </v-container>
                    </v-col>
                  </v-row>

                  <v-row align="center" justify="center">
                    <v-col cols=10>
                      <p>{{$t(singleStory.title)}}</p>
                    </v-col>
                    <v-col cols=2>
                      <v-btn icon x-small :disabled="cacheJourney.storiesArrayObjectIdDescription.length-1==0" color="" @click="removeStoryFromJourney(i)">
                        <span class="mdi mdi-delete-outline"></span>
                      </v-btn>
                    </v-col>

                  </v-row>
                </v-container>
              </div>

            </transition-group>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mediaFileStory from "@/components/mediaFileStory.vue";

export default {
  name: 'journeyEditDragAndDrop',
  data() {
    return {
      refreshComponentBackgroundColor:true,
      apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
      over: {},
      startLoc: 0,
      dragging: false,
      dragFrom: {}
    }

  },
  computed: {
    calcoulateBackgroundColor: {
      get: function () {
        if (this.cacheJourney.backgroundColor==1){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight1 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark1 + ')'
        }
        else if (this.cacheJourney.backgroundColor==2){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight2 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark2 + ')'
        }
        else if (this.cacheJourney.backgroundColor==3){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight3 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark3 + ')'
        }
        else  if (this.cacheJourney.backgroundColor==4){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight4 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark4 + ')'
        }
        else if (this.cacheJourney.backgroundColor==5){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight5 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark5 + ')'
        }
        else if (this.cacheJourney.backgroundColor==6){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight6 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark6 + ')'
        }
        else
        return ''

      }
    },
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    cacheJourney: {
      get: function () {
        return this.$store.getters.getNewJourneys
      }
    }

  },
  methods: {
    moveDownStory(index){
      this.refreshComponentBackgroundColor=false
      //swap story position i with story position i+1
      this.$store.dispatch("swapDownJourneyStoriesArrayObjectId",index).then(this.refreshComponentBackgroundColor=true)

    },
    moveUpStory(index){
      this.refreshComponentBackgroundColor=false
      //swap story position i with story position i+1
      this.$store.dispatch("swapUpJourneyStoriesArrayObjectId",index).then(this.refreshComponentBackgroundColor=true)

    },
/*the description of the story used in this journey is saved in vuex storage*/
    setSingleStoryJurneyDescription(index,description,storyId){
      let tempObj={index: index, description: description,storyId:storyId}
      this.$store.dispatch("setJourneyStoriesArrayObjectIdDescriptionDescriptionStoryJourney",tempObj)
    },



    initializeEmptyDescription() {
  this.singleStory = this.singleStory.map((obj) => {
    if(obj.storiesArrayObjectIdDescription)
    return obj
    obj.storiesArrayObjectIdDescription = ''
    return obj
  })
},

    removeStoryFromJourney(idStory) {
      this.arrayStories.splice(idStory, 1)
    },
    startDrag(singleStory, i, e) {
      this.startLoc = e.clientY;
      this.dragging = true;
      this.dragFrom = singleStory;
    },
    finishDrag(singleStory, pos) {
      this.arrayStories.splice(pos, 1)
      this.arrayStories.splice(this.over.pos, 0, singleStory);
      this.over = {}
    },
    onDragOver(singleStory, pos, e) {
      const dir = (this.startLoc < e.clientY) ? 'down' : 'up';
      setTimeout(() => {
        this.over = {
          singleStory,
          pos,
          dir
        };
      }, 50)
    },
    hideShow(value) {
      this.arrayStories[value].isVisible = !this.arrayStories[value].isVisible
    }
  },
  components: {
    mediaFileStory
  },
  props: {
    arrayStories: {
      type: Array,
      required: false
    }
  }
}
</script>

<style scoped>
.mdi-arrow-up-bold ,.mdi-arrow-down-bold{
  font-size: 26px;
}
.v-input__slot{
  display: none !important;
}

.v-text-field{
  margin-top: 0px!important;
  padding-top: 0px!important;
}

.v-text-field__details{
display: none;
}
.mdi.mdi-delete-outline{
font-size: 1.4rem;
}
.list > div {
    display: flex;
    flex-direction: column; 
}

.singleStory {
  /*width: 200px;*/
  padding: 1%;
  margin: 1%;
  border:1px solid black;
  font-family: sans-serif;
  border-radius: 5px;
  display: inline-block;
 /*transition: opacity .3s ease-in-out;*/
}

.flip-list-move {
  transition: transform .2s;
}


.over {
  opacity: .6;
}

.down {
    transform: translateY(-20px); 
}

.up {
    transform: translateY(20px);
}

</style>